import axiosInstance from '../../../../config/axiosInstance';
const  ContractFrequencyService = {
    async GetAllContractFrequency(redirectCallback) {
        try {            
            const ClientID=localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Setup/GetContractFrequency`);
            return response.data;
        } catch (error) {
            if(error.response.data.message=="Invalid token")
            {
                redirectCallback();
                return;
            }
            console.error('Error fetching data:', error);
            throw error;
        }
    },
};

export default ContractFrequencyService;